var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from "jquery";
export default class MobileMenu {
  constructor() {
    __publicField(this, "handleReset", (e) => {
      this.reset();
    });
    __publicField(this, "handleClick", (e) => {
      e.preventDefault();
      if (!this.iMenuOpen()) {
        this.$modal.modal("show");
      }
      const $link = $(e.currentTarget);
      const text = $link.attr("title");
      const depth = $link.data("depth");
      const href = $link.attr("href");
      const $nextTab = $(href);
      this.$currentSubMenu = $nextTab;
      this.setDepth(depth);
      this.addToHistory({
        text,
        href,
        depth
      });
      this.setBack();
      this.activateSubMenu();
    });
    __publicField(this, "handleBack", (e) => {
      e.preventDefault();
      const {href, depth} = this.removeLastFromHistory();
      this.setDepth(depth - 1);
      if (this.currentDepth > 0) {
        this.setBack();
      } else {
        this.setBack(true);
      }
      const $prevTab = $(href);
      setTimeout(() => {
        $prevTab.removeClass("active");
      }, 300);
    });
    $("body").append($("#mobile_menu").detach());
    this.$menuContent = $(".js-mobile-menu");
    this.$tabLinks = $(".js-mobile-menu-tab-link");
    this.$menuBack = $(".js-mobile-menu-back");
    this.$menuLists = $(".js-mobile-menu-list");
    this.$modal = $("#mobile_menu");
    this.$currentSubMenu = null;
    this.currentDepth = 0;
    this.menuHistory = [];
    this.menuOpen = false;
  }
  init() {
    this.reset();
    this.$tabLinks.on("click", this.handleClick);
    this.$menuBack.on("click", this.handleBack);
    this.$modal.on("hidden.bs.modal", this.handleReset);
    this.$modal.on("show.bs.modal", () => {
      this.menuOpen = true;
    });
    this.$modal.on("hide.bs.modal", () => {
      this.menuOpen = false;
    });
  }
  iMenuOpen() {
    return this.menuOpen;
  }
  addToHistory(historyEl) {
    this.menuHistory.push(historyEl);
  }
  removeLastFromHistory() {
    return this.menuHistory.pop();
  }
  getHistoryElByDepth(depth) {
    return this.menuHistory[depth - 1];
  }
  activateSubMenu() {
    this.$currentSubMenu.addClass("active");
  }
  reset() {
    this.currentDepth = 0;
    this.menuHistory = [];
    this.setBack(true);
    this.$menuLists.removeClass("active");
    this.moveMenuToDepth();
  }
  setDepth(depth) {
    this.currentDepth = depth;
    this.moveMenuToDepth();
  }
  setBack(remove = false) {
    if (remove) {
      this.$menuBack.text("");
      this.$menuBack.removeAttr("href");
      this.$menuBack.removeAttr("data-depth");
    } else {
      const {text, href, depth} = this.getHistoryElByDepth(this.currentDepth);
      this.$menuBack.text(text);
      this.$menuBack.attr("href", href);
      this.$menuBack.attr("data-depth", depth);
    }
  }
  moveMenuToDepth() {
    if (this.currentDepth > 0) {
      this.$menuContent.css({
        transform: `translateX(-${this.currentDepth * 100}%)`
      });
    } else {
      this.$menuContent.css({
        transform: `translateX(0)`
      });
    }
  }
}
